(function($) {
  // jQuery-menu-aim v1.1 by Ben Kamens
  // MIT License 2013
  // https://github.com/kamens/jQuery-menu-aim
  function clan_aiming($menu) {
    var activeRow = null,
        mouseLocs = [],
        lastDelayLoc = null,
        timeoutId = null,
        tolerance = 75

    var MOUSE_LOCS_TRACKED = 3,  // number of past mouse locations to track
        DELAY = 300;  // ms delay when user appears to be entering submenu

    // Keep track of the last few locations of the mouse.
    var mousemoveDocument = function(e) {
      mouseLocs.push({x: e.pageX, y: e.pageY});

      if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
        mouseLocs.shift();
      }
    };

    // Cancel possible row activations when leaving the menu entirely
    var mouseleaveMenu = function() {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (activeRow) {
        $(activeRow).removeClass('aiming');
      }

      activeRow = null;
    };

    // Trigger a possible row activation whenever entering a new row
    var mouseenterRow = function() {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      possiblyActivate(this);
    };

    // Immediately activate a row if the user clicks on it
    var clickRow = function() {
      activate(this);
    };

    // Activate a menu row
    var activate = function(row) {
      if (row == activeRow) {
        return;
      }

      if (activeRow) {
        $(activeRow).removeClass('aiming');
      }

      $menu.find('> *:focus').blur();

      $(row).addClass('aiming');
      activeRow = row;
    };

    // Possibly activate a menu row. If mouse movement indicates that we shouldn't activate yet
    // because user may be trying to enter a submenu's content, then delay and check again later.
    var possiblyActivate = function(row) {
      var delay = activationDelay();

      if (delay) {
        timeoutId = setTimeout(function() {
          possiblyActivate(row);
        }, delay);
      } else {
        activate(row);
      }
    };

    // Return the amount of time that should be used as a delay before the currently hovered row is activated.
    var activationDelay = function() {
      if (!activeRow || !$(activeRow).is('.cw-clan')) {
        return 0;
      }

      var offset = $menu.offset(),
        upperLeft = {
            x: offset.left,
            y: offset.top - tolerance
        },
        upperRight = {
            x: offset.left + $menu.outerWidth(),
            y: upperLeft.y
        },
        lowerLeft = {
            x: offset.left,
            y: offset.top + $menu.outerHeight() + tolerance
        },
        lowerRight = {
            x: offset.left + $menu.outerWidth(),
            y: lowerLeft.y
        },
        loc = mouseLocs[mouseLocs.length - 1],
        prevLoc = mouseLocs[0];

      if (!loc) {
        return 0;
      }

      if (!prevLoc) {
        prevLoc = loc;
      }

      if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x || prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
        // If the previous mouse location was outside of the entire menu's bounds, immediately activate.
        return 0;
      }

      if (lastDelayLoc && loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
        // If the mouse hasn't moved since the last time we checked for activation status, immediately activate.
        return 0;
      }

      // Detect if the user is moving towards the currently activated submenu.
      function slope(a, b) {
        return (b.y - a.y) / (b.x - a.x);
      };

      var decreasingCorner = upperRight,
          increasingCorner = lowerRight;

      var decreasingSlope = slope(loc, decreasingCorner),
          increasingSlope = slope(loc, increasingCorner),
          prevDecreasingSlope = slope(prevLoc, decreasingCorner),
          prevIncreasingSlope = slope(prevLoc, increasingCorner);

      if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
        // Mouse is moving from previous location towards the currently activated submenu.
        // Delay before activating a new menu row, because user may be moving into submenu.
        lastDelayLoc = loc;
        return DELAY;
      }

      lastDelayLoc = null;
      return 0;
    };

    $menu.mouseleave(mouseleaveMenu).find('> li').mouseenter(mouseenterRow).click(clickRow);

    $(document).mousemove(mousemoveDocument);
  };

  $(document).ready(function(){
    var language = $('html').attr('lang').replace('de', 'du');
  });
})(jQuery);
